import editarAreaCustomerForm from './editarAreaFormModel';
const {
  formField: {
    // DATOS CLIENTE
    e_name,
    e_description,
    e_sucursal,
  },
} = editarAreaCustomerForm;

export default {
  [e_name.name]: '',
  [e_description.name]: '',
  [e_sucursal.name]: '',
};
